if (!customElements.get('adev-open-enquire-popup')) {
    customElements.define('adev-open-enquire-popup', class adevOpenEnquirePopup extends HTMLElement {
        constructor() {
            super();
        }

        handleClick() {
            const popup = document.querySelector('adev-enquire-product');
            if (popup) {
                popup.open();
            }
        }

        connectedCallback() {
            this.addEventListener('click', this.handleClick.bind(this));
        }

        disconnectedCallback() {
            this.removeEventListener('click', this.handleClick.bind(this));
        }

    });
}


if (!customElements.get('adev-enquire-product')) {
    customElements.define('adev-enquire-product', class adevEnquireProduct extends HTMLElement {
        constructor() {
            super();
        }

        init() {
            const href = window.location.href;

            if (href.indexOf('contact_posted=true#enquire-product-form') !== -1) {
                this.open();

                const url = new URL(href);
                url.hash = '';
                url.searchParams.delete('contact_posted');
                window.history.replaceState({}, document.title, url.toString());
            }
        }

        open() {
            this.classList.add('is--active');
        }

        close() {
            this.classList.remove('is--active');
        }

        outsideClickListener(event) {
            if (event.target === this) {
                this.close();
            }
        }

        connectedCallback() {
            this.querySelectorAll('[data-adev-enquire-product="close"]').forEach((btn) => {
                btn.addEventListener('click', this.close.bind(this));
            });

            this.init();

            this.addEventListener('click', this.outsideClickListener.bind(this));
        }

        disconnectedCallback() {
            this.querySelectorAll('[data-adev-enquire-product="close"]').forEach((btn) => {
                btn.removeEventListener('click', this.close.bind(this));
            });

            this.removeEventListener('click', this.outsideClickListener.bind(this));
        }

    });
}